import React, { Component } from 'react';
import {Button} from '@betareader/design-system';
import { withTranslation } from 'react-i18next';

import PostPrivacySelector from '../../components/feed/postPrivacySelector';
import TextAreaWithSave from '../../components/inputs/TextAreaWithSave';

let dropzoneDragCounter = 0;

export class NewBookPost extends Component {
  constructor(props) {
    super(props);

    this.state = {
      text: '',
      files: [],
      privacy: 0
    };
  }

  componentDidMount() {
    // this.fileSelector = this.buildFileSelector();
  }

  onTextChanged = (event) => {
    this.setState({
      text: event.target.value
    });
  }

  postBookPost = (event) => {
    event?.preventDefault();
    const { text, privacy, files } = this.state;
    const postData = new FormData();
    postData.append('text', text);
    postData.append('privacy', privacy);
    files.forEach((file, index) => {
      postData.append('images', file, `image_${index}`);
    });
    if (this.props.onNewBookPost) {
      this.props.onNewBookPost(postData, (success) => {
        if (success) {
          this.setState({
            text: '',
            files: []
          });
        }
      });
    }
  }

  onNewFiles = (event) => {
    // Prevent default behavior (Prevent file from being opened)
    let files;
    if (event.target.files) {
      files = [...event.target.files];
    } else if (event.dataTransfer.items) {
      // Use DataTransferItemList interface to access the file(s)
      files = [...event.dataTransfer.items];
    } else {
      // Use DataTransfer interface to access the file(s)
      files = [...event.dataTransfer.files];
    }
    this.handleFiles(files);
  }

  handleFiles = (files) => {
    const newFiles = [];
    files.forEach((file) => {
      if (file.getAsFile) {
        newFiles.push(file.getAsFile());
      } else {
        newFiles.push(file);
      }
    });
    this.setState(prevState => ({
      files: [...prevState.files, ...newFiles]
    }), () => {
      [...this.state.files].forEach(this.generatePreview);
    });
  }

  generatePreview = (file, index) => {
    // create a file reader
    if (file.preview) {
      return;
    }
    const reader = new FileReader();
    // handle the result of the file reader
    reader.onloadend = () => {
      this.setState((prevState) => {
        const updatedFiles = [...prevState.files];
        updatedFiles[index].preview = reader.result;
        return ({
          files: [...updatedFiles]
        });
      });
    };
    // start reading the file
    if (file) {
      reader.readAsDataURL(file);
    }
  }

  canPost = () => {
    const { text, files } = this.state;
    return (text !== undefined && text.length > 0) || (files !== undefined && files.length > 0);
  }

  toggleImageUpload = (event) => {
    event.preventDefault();
    if (this.fileSelector) {
      this.fileSelector.click();
    }
  }

  fileInputRef = (ref) => {
    this.fileSelector = ref;
  };

  removeFile = (fileIndex) => {
    this.setState(prevState => ({
      files: [...prevState.files].filter((file, index) => index !== fileIndex)
    }));
  }

  preventDefaults = (event) => {
    event.stopPropagation();
    event.preventDefault();
  }

  onDragEnter = (event) => {
    this.preventDefaults(event);
    dropzoneDragCounter += 1;
    if (dropzoneDragCounter > 0) {
      this.setState({
        dropzoneReady: true
      });
    }
  }

  onDragLeave = (event) => {
    this.preventDefaults(event);
    dropzoneDragCounter -= 1;
    if (dropzoneDragCounter === 0) {
      this.setState({
        dropzoneReady: false
      });
    }
  }

  onDrop = (event) => {
    this.preventDefaults(event);
    dropzoneDragCounter = 0;
    this.setState({
      dropzoneReady: false
    });
    this.onNewFiles(event);
  }

  handlePostPrivacyChange = (event, data) => {
    this.setState({ privacy: data.value });
  }

  render() {
    const { t, isPosting, dragging } = this.props;
    const {
      text, files, dropzoneReady, privacy
    } = this.state;
    return (
      <form
        className="br-card br-new-book-post"
        onSubmit={this.postBookPost}
        onDragOver={this.preventDefaults}
        onDragEnter={this.preventDefaults}
        onDragLeave={this.preventDefaults}
        aria-busy={isPosting ? 'true' : 'false'}
      >
        <h2>{t('CreatePost')}</h2>
        {
          (!dragging && !dropzoneReady)
          && (
            <>
              <label className="br-field">
                <span className="br-field__label">{t('NewBookPostPlaceholder')}</span>
                <TextAreaWithSave
                  placeholder={t('NewBookPostPlaceholder')}
                  value={text}
                  onChange={this.onTextChanged}
                  onSave={this.postBookPost}
                  disabled={isPosting}
                />
              </label>
              {files.some(file => file.preview) && (
                <ul className="br-new-book-post__previews">
                  {files.map((file, index) => file.preview && (
                    <li key={`${file.name}-${index}`}>
                      <img src={file.preview} alt={`${file.name || 'Image'} preview`} />
                      <Button
                        variant="ghost"
                        size="small"
                        onClick={() => this.removeFile(index)}
                        aria-label={`${t('Remove')} ${file.name || index + 1}`}
                      >×</Button>
                    </li>
                  ))}
                </ul>
              )}
              <div className="br-new-book-post__actions">
                <Button variant="secondary" onClick={this.toggleImageUpload}>
                  {t('AddImages', 'Add images')}
                </Button>
                <input ref={this.fileInputRef} multiple accept="image/png,image/jpeg" type="file" name="images" onChange={this.onNewFiles} className="br-new-book-post__file-input" aria-label={t('AddImages', 'Add images')} />
                <PostPrivacySelector
                  style={{ alignSelf: 'center', marginRight: '1em' }}
                  value={privacy}
                  onChange={this.handlePostPrivacyChange}
                />
                <Button
                  disabled={!this.canPost()}
                  type='submit'
                >{isPosting ? t('Posting', 'Posting…') : t('Share')}</Button>
              </div>
            </>
          )
        }
        {
          (dragging || dropzoneReady)
          && (
            <div
              className="dropzone br-new-book-post__dropzone"
              onDragOver={this.preventDefaults}
              onDragEnter={this.onDragEnter}
              onDragLeave={this.onDragLeave}
              onDrop={this.onDrop}
            >
              {t('DropFilesHere')}
            </div>
          )
        }
      </form>
    );
  }
}
export default withTranslation()(NewBookPost);
